import React from 'react';
import { fieldClass } from './TextField';
type TextAreaFieldProps = React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
  label: string;
  name: string;
  error?: string;
};
export function TextAreaField({
  label,
  name,
  error,
  required,
  className = '',
  rows = 5,
  ...rest
}: TextAreaFieldProps) {
  const id = `field-${name}`;
  return <div className={className} data-id="element-72" data-mp="2ipn78h088lny">
      <label htmlFor={id} className="font-slab text-sm font-bold uppercase tracking-[0.18em] text-cream" data-id="element-73" data-mp="2wicsgj7xlmk0">
        {label}
        {required && <span className="text-neon-2" data-id="element-74" data-mp="2sfpyocrp9rk6"> *</span>}
      </label>
      <textarea id={id} name={name} rows={rows} required={required} aria-invalid={!!error} aria-describedby={error ? `${id}-error` : undefined} className={`${fieldClass} resize-y ${error ? 'border-red-400' : ''}`} {...rest} data-id="element-75" data-mp="36gitkylwyont" />
      {error && <p id={`${id}-error`} className="mt-1.5 text-xs text-red-300" data-id="element-76" data-mp="173yachrf4xxh">
          {error}
        </p>}
    </div>;
}